export default __webpack_public_path__ + "static/media/4518956_adobe_file_pdf_type_icon.c65fba40.png";